import { Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import React from "react";

const useStyles = makeStyles(() => ({
  chip: {
    color: "#06F",
    fontFamily: "Inter, sans-serif",
    margin: "1px 5px",
    fontSize: "12px",
    fontWeight: "300",
  },
}));

export default ({ label }) => {
  return (
    <Chip
      component="span"
      variant="outlined"
      icon={<CheckCircleOutlineIcon />}
      label={label}
      className={useStyles().chip}
      color="primary"
      size="small"
    />
  );
};
